module.exports = __webpack_public_path__ + "img/plan3_text.a4275e31.png";